import { ConfigProvider } from 'antd'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import { toast, Toaster } from 'react-hot-toast'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { RecoilRoot } from 'recoil'
import { SWRConfig } from 'swr'
import { Api } from './api'
import './App.css'
import { Fa } from './components/Fa'
import { Root } from './components/Root'
import { getAntLocale } from './i18n'
import { Classes } from './pages/Classes'
import { Paychoice } from './pages/Paychoice'
import { Payrix } from './pages/Payrix'
import { Pricing } from './pages/Pricing'
import { Purchase } from './pages/Purchase'
import { Stripe } from './pages/Stripe'
import { TermsConditions } from './pages/TermsConditions'
import { themeMeta } from './theme/meta'

function App() {
  return (
    <RecoilRoot>
      <HelmetProvider>
        <Helmet titleTemplate="%s - Xoda"></Helmet>
        <SWRConfig
          value={{
            fetcher: (uri, data) => Api.get(uri, data),
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            revalidateIfStale: false,
            shouldRetryOnError: false,
            onError: (error) => {
              if (error instanceof Error) {
                /**
                 * @todo Don't know why it can't show up immediately.
                 */
                setTimeout(() => {
                  toast.error(error.message)
                }, 100)
              }
            },
          }}
        >
          <ConfigProvider locale={getAntLocale()}>
            <Root>
              <Toaster
                toastOptions={{
                  position: 'bottom-center',
                  style: {
                    ...themeMeta.typography.textSmallBold,
                    gap: '0.25rem',
                    maxWidth: 'none',
                    padding: '0.9375rem 1.2rem',
                    color: themeMeta.colors.monochrome.white,
                    background: themeMeta.colors.monochrome.offBlack,
                    borderRadius: '0.6rem',
                    boxShadow: 'none',
                  },
                  success: {
                    icon: (
                      <Fa
                        name="circle-check"
                        color={themeMeta.colors.primary.default}
                      />
                    ),
                  },
                  error: {
                    icon: (
                      <Fa
                        name="circle-xmark"
                        color={themeMeta.colors.error.default}
                      />
                    ),
                  },
                }}
              />
              <BrowserRouter>
                <Routes>
                  <Route path="classes" element={<Classes />} />
                  <Route path="stripe" element={<Stripe />} />
                  <Route path="paychoice" element={<Paychoice />} />
                  <Route path="payrix" element={<Payrix />} />
                  <Route path="purchase/:type/:id" element={<Purchase />} />
                  <Route path="pricing" element={<Pricing />} />
                  <Route
                    path="terms-conditions"
                    element={<TermsConditions />}
                  />
                </Routes>
              </BrowserRouter>
            </Root>
          </ConfigProvider>
        </SWRConfig>
      </HelmetProvider>
    </RecoilRoot>
  )
}

export { App }
